export default __webpack_public_path__ + "static/media/volunteer.36fcde3d.png";